exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-blanco[data-v-4f3b2add]{padding-bottom:50px}.section[data-v-4f3b2add]{padding:3rem 1.5rem}.tabs ul[data-v-4f3b2add]{border-bottom-color:inherit;border-bottom-style:solid;border-bottom-width:0}.is-active[data-v-4f3b2add]{border-bottom-color:#3273dc;border-bottom-style:solid;border-bottom-width:1px}@media (min-width:320px) and (max-width:480px){.section[data-v-4f3b2add]{padding:3rem .5rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f3b2add","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/estaciones_Componentes/Monitor.vue
// module id = 2608
// module chunks = 0